// extracted by mini-css-extract-plugin
module.exports = {"image":"forgotPasswordEmail_image__2kNDy","textContainer":"forgotPasswordEmail_textContainer__3frEs"};